var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('GmapMarker',{attrs:{"visible":_vm.visible,"position":{lat: _vm.position.latitude, lng: _vm.position.longitude},"icon":_vm.truckIcon,"animation":_vm.animation},on:{"click":_vm.onClick,"mouseover":function($event){return _vm.$emit('mouseover')},"mouseout":function($event){return _vm.$emit('mouseout')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }